export default "annet,Annet\nkomm,Kommune\nweb,Kommune-Web\nnibio,NIBIO\njm,NIBIO-JM\nskog,NIBIO-Skog\nok,NIBIO-ØK\nsamf,Samferdsel\nvann,Vann\n"